import { metrics } from "@opentelemetry/api";

let customGeojsonHydrateHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let customGeojsonTotalHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let layerFetchHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let customGeojsonPointsCountHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let customGeojsonLinesCountHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let customGeojsonPolygonsCountHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null =
  null;
let webVitalLcpHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let webVitalInpHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let webVitalFcpHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let webVitalTtfbHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let webVitalClsHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let animationExportFrameProcessingHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null =
  null;
let animationExportFrameCaptureHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null =
  null;
let animationExportFrameWorkerHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null =
  null;
let animationExportFrameBackpressureHistogram: ReturnType<
  ReturnType<typeof metrics.getMeter>["createHistogram"]
> | null = null;
let animationExportFrameWaitReadyHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null =
  null;
let animationExportFinalizeHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let animationExportRunProcessingHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null =
  null;
let animationExportRunFramesHistogram: ReturnType<ReturnType<typeof metrics.getMeter>["createHistogram"]> | null = null;
let animationExportRunsCounter: ReturnType<ReturnType<typeof metrics.getMeter>["createCounter"]> | null = null;

type MetricAttributes = Record<string, string | number | boolean>;
export type AnimationExportRunOutcome = "success" | "canceled" | "error";

function getMeter() {
  return metrics.getMeter("metx-frontend");
}

function getCustomGeojsonHydrateHistogram() {
  if (customGeojsonHydrateHistogram) {
    return customGeojsonHydrateHistogram;
  }

  customGeojsonHydrateHistogram = getMeter().createHistogram("customgeojson_layer_hydrate_ms", {
    description: "Custom GeoJSON layer hydrate duration.",
    unit: "ms",
  });
  return customGeojsonHydrateHistogram;
}

function getCustomGeojsonTotalHistogram() {
  if (customGeojsonTotalHistogram) {
    return customGeojsonTotalHistogram;
  }

  customGeojsonTotalHistogram = getMeter().createHistogram("customgeojson_layer_total_ms", {
    description: "Custom GeoJSON layer total duration.",
    unit: "ms",
  });
  return customGeojsonTotalHistogram;
}

function getLayerFetchHistogram() {
  if (layerFetchHistogram) {
    return layerFetchHistogram;
  }

  layerFetchHistogram = getMeter().createHistogram("layer_data_fetch_ms", {
    description: "Layer data fetch duration.",
    unit: "ms",
  });
  return layerFetchHistogram;
}

function getCustomGeojsonPointsCountHistogram() {
  if (customGeojsonPointsCountHistogram) {
    return customGeojsonPointsCountHistogram;
  }

  customGeojsonPointsCountHistogram = getMeter().createHistogram("customgeojson_points_count", {
    description: "Custom GeoJSON points count.",
    unit: "1",
  });
  return customGeojsonPointsCountHistogram;
}

function getCustomGeojsonLinesCountHistogram() {
  if (customGeojsonLinesCountHistogram) {
    return customGeojsonLinesCountHistogram;
  }

  customGeojsonLinesCountHistogram = getMeter().createHistogram("customgeojson_lines_count", {
    description: "Custom GeoJSON line strings count.",
    unit: "1",
  });
  return customGeojsonLinesCountHistogram;
}

function getCustomGeojsonPolygonsCountHistogram() {
  if (customGeojsonPolygonsCountHistogram) {
    return customGeojsonPolygonsCountHistogram;
  }

  customGeojsonPolygonsCountHistogram = getMeter().createHistogram("customgeojson_polygons_count", {
    description: "Custom GeoJSON polygons count.",
    unit: "1",
  });
  return customGeojsonPolygonsCountHistogram;
}

function getWebVitalLcpHistogram() {
  if (webVitalLcpHistogram) {
    return webVitalLcpHistogram;
  }
  webVitalLcpHistogram = getMeter().createHistogram("web_vital_lcp_ms", {
    description: "Largest Contentful Paint (ms).",
    unit: "ms",
  });
  return webVitalLcpHistogram;
}

function getWebVitalInpHistogram() {
  if (webVitalInpHistogram) {
    return webVitalInpHistogram;
  }
  webVitalInpHistogram = getMeter().createHistogram("web_vital_inp_ms", {
    description: "Interaction to Next Paint (ms).",
    unit: "ms",
  });
  return webVitalInpHistogram;
}

function getWebVitalFcpHistogram() {
  if (webVitalFcpHistogram) {
    return webVitalFcpHistogram;
  }
  webVitalFcpHistogram = getMeter().createHistogram("web_vital_fcp_ms", {
    description: "First Contentful Paint (ms).",
    unit: "ms",
  });
  return webVitalFcpHistogram;
}

function getWebVitalTtfbHistogram() {
  if (webVitalTtfbHistogram) {
    return webVitalTtfbHistogram;
  }
  webVitalTtfbHistogram = getMeter().createHistogram("web_vital_ttfb_ms", {
    description: "Time to First Byte (ms).",
    unit: "ms",
  });
  return webVitalTtfbHistogram;
}

function getWebVitalClsHistogram() {
  if (webVitalClsHistogram) {
    return webVitalClsHistogram;
  }
  webVitalClsHistogram = getMeter().createHistogram("web_vital_cls", {
    description: "Cumulative Layout Shift.",
    unit: "1",
  });
  return webVitalClsHistogram;
}

function getAnimationExportFrameProcessingHistogram() {
  if (animationExportFrameProcessingHistogram) {
    return animationExportFrameProcessingHistogram;
  }
  animationExportFrameProcessingHistogram = getMeter().createHistogram("animation_export_frame_processing_ms", {
    description: "Animation export per-frame processing duration (excluding scene readiness wait).",
    unit: "ms",
  });
  return animationExportFrameProcessingHistogram;
}

function getAnimationExportFrameCaptureHistogram() {
  if (animationExportFrameCaptureHistogram) {
    return animationExportFrameCaptureHistogram;
  }
  animationExportFrameCaptureHistogram = getMeter().createHistogram("animation_export_frame_capture_ms", {
    description: "Animation export per-frame snapshot capture duration.",
    unit: "ms",
  });
  return animationExportFrameCaptureHistogram;
}

function getAnimationExportFrameWorkerHistogram() {
  if (animationExportFrameWorkerHistogram) {
    return animationExportFrameWorkerHistogram;
  }
  animationExportFrameWorkerHistogram = getMeter().createHistogram("animation_export_frame_worker_ms", {
    description: "Animation export per-frame video worker processing duration.",
    unit: "ms",
  });
  return animationExportFrameWorkerHistogram;
}

function getAnimationExportFrameBackpressureHistogram() {
  if (animationExportFrameBackpressureHistogram) {
    return animationExportFrameBackpressureHistogram;
  }
  animationExportFrameBackpressureHistogram = getMeter().createHistogram("animation_export_frame_backpressure_ms", {
    description: "Animation export per-frame waiting time caused by in-flight frame backpressure.",
    unit: "ms",
  });
  return animationExportFrameBackpressureHistogram;
}

function getAnimationExportFrameWaitReadyHistogram() {
  if (animationExportFrameWaitReadyHistogram) {
    return animationExportFrameWaitReadyHistogram;
  }
  animationExportFrameWaitReadyHistogram = getMeter().createHistogram("animation_export_frame_wait_ready_ms", {
    description: "Animation export per-frame scene readiness wait duration (diagnostic).",
    unit: "ms",
  });
  return animationExportFrameWaitReadyHistogram;
}

function getAnimationExportFinalizeHistogram() {
  if (animationExportFinalizeHistogram) {
    return animationExportFinalizeHistogram;
  }
  animationExportFinalizeHistogram = getMeter().createHistogram("animation_export_finalize_ms", {
    description: "Animation export finalization duration (process video).",
    unit: "ms",
  });
  return animationExportFinalizeHistogram;
}

function getAnimationExportRunProcessingHistogram() {
  if (animationExportRunProcessingHistogram) {
    return animationExportRunProcessingHistogram;
  }
  animationExportRunProcessingHistogram = getMeter().createHistogram("animation_export_run_processing_ms", {
    description: "Animation export run processing duration (sum of frame processing plus finalization).",
    unit: "ms",
  });
  return animationExportRunProcessingHistogram;
}

function getAnimationExportRunFramesHistogram() {
  if (animationExportRunFramesHistogram) {
    return animationExportRunFramesHistogram;
  }
  animationExportRunFramesHistogram = getMeter().createHistogram("animation_export_run_frames", {
    description: "Animation export number of successfully processed frames per run.",
    unit: "1",
  });
  return animationExportRunFramesHistogram;
}

function getAnimationExportRunsCounter() {
  if (animationExportRunsCounter) {
    return animationExportRunsCounter;
  }
  animationExportRunsCounter = getMeter().createCounter("animation_export_runs_total", {
    description: "Animation export runs grouped by outcome.",
    unit: "1",
  });
  return animationExportRunsCounter;
}

function isValidNonNegative(value: number): boolean {
  return Number.isFinite(value) && value >= 0;
}

export function recordCustomGeojsonHydrateMs(args: {
  durationMs: number;
  op: string;
  mode: "backend" | "frontend";
  didFrontendHydrate?: boolean;
  attributes?: MetricAttributes;
}): void {
  if (!Number.isFinite(args.durationMs) || args.durationMs < 0) {
    return;
  }

  const attributes = {
    layer: "custom_geojson",
    op: args.op,
    mode: args.mode,
    ...(args.didFrontendHydrate !== undefined ? { didFrontendHydrate: args.didFrontendHydrate } : {}),
    ...(args.attributes ?? {}),
  };

  getCustomGeojsonHydrateHistogram().record(args.durationMs, attributes);
}

export function recordCustomGeojsonTotalMs(args: {
  durationMs: number;
  op: string;
  mode: "backend" | "frontend";
  didFrontendHydrate?: boolean;
  attributes?: MetricAttributes;
}): void {
  if (!Number.isFinite(args.durationMs) || args.durationMs < 0) {
    return;
  }

  const attributes = {
    layer: "custom_geojson",
    op: args.op,
    mode: args.mode,
    ...(args.didFrontendHydrate !== undefined ? { didFrontendHydrate: args.didFrontendHydrate } : {}),
    ...(args.attributes ?? {}),
  };

  getCustomGeojsonTotalHistogram().record(args.durationMs, attributes);
}

export function recordLayerFetchMs(args: {
  durationMs: number;
  source: string;
  layerKind?: string;
  mode?: string;
  op?: string;
  kind?: string;
  attributes?: MetricAttributes;
}): void {
  if (!Number.isFinite(args.durationMs) || args.durationMs < 0) {
    return;
  }

  const attributes: MetricAttributes = {
    source: args.source,
  };

  if (args.layerKind) {
    attributes.layerKind = args.layerKind;
  }
  if (args.mode) {
    attributes.mode = args.mode;
  }
  if (args.op) {
    attributes.op = args.op;
  }
  if (args.kind) {
    attributes.kind = args.kind;
  }
  if (args.attributes) {
    Object.assign(attributes, args.attributes);
  }

  getLayerFetchHistogram().record(args.durationMs, attributes);
}

export function recordCustomGeojsonCounts(args: {
  nPoints: number;
  nLines: number;
  nPolygons: number;
  mode?: string;
  attributes?: MetricAttributes;
}): void {
  if (!Number.isFinite(args.nPoints) || args.nPoints < 0) {
    return;
  }
  if (!Number.isFinite(args.nLines) || args.nLines < 0) {
    return;
  }
  if (!Number.isFinite(args.nPolygons) || args.nPolygons < 0) {
    return;
  }

  const attributes: MetricAttributes = {};
  if (args.mode) {
    attributes.mode = args.mode;
  }
  if (args.attributes) {
    Object.assign(attributes, args.attributes);
  }

  getCustomGeojsonPointsCountHistogram().record(args.nPoints, attributes);
  getCustomGeojsonLinesCountHistogram().record(args.nLines, attributes);
  getCustomGeojsonPolygonsCountHistogram().record(args.nPolygons, attributes);
}

export function recordAnimationExportFrameProcessingMs(args: {
  durationMs: number;
  attributes?: MetricAttributes;
}): void {
  if (!isValidNonNegative(args.durationMs)) {
    return;
  }
  getAnimationExportFrameProcessingHistogram().record(args.durationMs, args.attributes);
}

export function recordAnimationExportFrameCaptureMs(args: {
  durationMs: number;
  attributes?: MetricAttributes;
}): void {
  if (!isValidNonNegative(args.durationMs)) {
    return;
  }
  getAnimationExportFrameCaptureHistogram().record(args.durationMs, args.attributes);
}

export function recordAnimationExportFrameWorkerMs(args: {
  durationMs: number;
  attributes?: MetricAttributes;
}): void {
  if (!isValidNonNegative(args.durationMs)) {
    return;
  }
  getAnimationExportFrameWorkerHistogram().record(args.durationMs, args.attributes);
}

export function recordAnimationExportFrameBackpressureMs(args: {
  durationMs: number;
  attributes?: MetricAttributes;
}): void {
  if (!isValidNonNegative(args.durationMs)) {
    return;
  }
  getAnimationExportFrameBackpressureHistogram().record(args.durationMs, args.attributes);
}

export function recordAnimationExportFrameWaitReadyMs(args: {
  durationMs: number;
  attributes?: MetricAttributes;
}): void {
  if (!isValidNonNegative(args.durationMs)) {
    return;
  }
  getAnimationExportFrameWaitReadyHistogram().record(args.durationMs, args.attributes);
}

export function recordAnimationExportFinalizeMs(args: {
  durationMs: number;
  attributes?: MetricAttributes;
}): void {
  if (!isValidNonNegative(args.durationMs)) {
    return;
  }
  getAnimationExportFinalizeHistogram().record(args.durationMs, args.attributes);
}

export function recordAnimationExportRunProcessingMs(args: {
  durationMs: number;
  attributes?: MetricAttributes;
}): void {
  if (!isValidNonNegative(args.durationMs)) {
    return;
  }
  getAnimationExportRunProcessingHistogram().record(args.durationMs, args.attributes);
}

export function recordAnimationExportRunFrames(args: {
  frames: number;
  attributes?: MetricAttributes;
}): void {
  if (!isValidNonNegative(args.frames)) {
    return;
  }
  getAnimationExportRunFramesHistogram().record(args.frames, args.attributes);
}

export function recordAnimationExportRunsTotal(args: {
  outcome: AnimationExportRunOutcome;
  attributes?: MetricAttributes;
}): void {
  const attributes = {
    ...(args.attributes ?? {}),
    outcome: args.outcome,
  };
  getAnimationExportRunsCounter().add(1, attributes);
}

export function recordWebVital(name: string, value: number): void {
  if (!Number.isFinite(value) || value < 0) {
    return;
  }

  switch (name) {
    case "LCP":
      getWebVitalLcpHistogram().record(value);
      break;
    case "INP":
      getWebVitalInpHistogram().record(value);
      break;
    case "FCP":
      getWebVitalFcpHistogram().record(value);
      break;
    case "TTFB":
      getWebVitalTtfbHistogram().record(value);
      break;
    case "CLS":
      getWebVitalClsHistogram().record(value);
      break;
    default:
      break;
  }
}
